<template lang="pug">
  span(v-if="project")
    | {{project.client | text }}
    |
    span.italic {{project.title | text}}
</template>

<script>
export default {
  name: 'ViewerFooter__ActiveTitle',
  props: ['project']
}
</script>



// WEBPACK FOOTER //
// src/components/SeriesViewerFooter__ActiveTitle.vue